import { render, staticRenderFns } from "./ActionPerformedBlock.vue?vue&type=template&id=539e30b9&scoped=true&"
import script from "./ActionPerformedBlock.vue?vue&type=script&lang=ts&"
export * from "./ActionPerformedBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e30b9",
  null
  
)

export default component.exports